import { render, staticRenderFns } from "./ChannelFourNews.vue?vue&type=template&id=e4773dbc&scoped=true"
import script from "./ChannelFourNews.vue?vue&type=script&lang=js"
export * from "./ChannelFourNews.vue?vue&type=script&lang=js"
import style0 from "./ChannelFourNews.vue?vue&type=style&index=0&id=e4773dbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4773dbc",
  null
  
)

export default component.exports